export enum ApparelCategoryPricingRole {
  PriceRange = 'price_range', // calcolo del prezzo dei prodotti mtm as is
  StyleMaterial = 'style_material', // calcolo prezzo dello sportswear
}
